import React from 'react';
import PropTypes from 'prop-types';
import { Container, Decorations } from './NavBar.style';
import filterHtmlProps from '../../utils/filterHtmlProps';

const NavBar = ({ className, children, bottomDecoration, ...otherProps }) => {
  const htmlProps = filterHtmlProps(otherProps);

  return (
    <Container className={className} {...htmlProps}>
      <Decorations>{children}</Decorations>
      <Decorations>{bottomDecoration}</Decorations>
    </Container>
  );
};

NavBar.defaultProps = {
  className: undefined,
  bottomDecoration: undefined,
  children: null,
};

NavBar.propTypes = {
  className: PropTypes.string,
  bottomDecoration: PropTypes.element,
  children: PropTypes.node,
};

export default NavBar;
